import { analyticsProps } from '@class-ui/insights';
import { Box, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledHeaderContainer = styled(Box)`
    display: flex;
    padding: 16px 0px 16px 24px;
`;

const InviteStudentsHeader = () => {
    const { t } = useTranslation('invite_students');

    return (
        <StyledHeaderContainer>
            <Typography variant="h6" {...analyticsProps('invite-students-header')}>
                {t('header.settings')}
            </Typography>
        </StyledHeaderContainer>
    );
};

export default InviteStudentsHeader;
